import React from 'react';
import { VERSION_INFO } from './version';

const VersionDisplay = ({ position = 'bottom-right' }) => {
    const styles = {
        container: {
            position: 'fixed',
            bottom: position.includes('bottom') ? '10px' : 'auto',
            top: position.includes('top') ? '10px' : 'auto',
            right: position.includes('right') ? '10px' : 'auto',
            left: position.includes('left') ? '10px' : 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            color: '#fff',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontFamily: 'monospace',
            zIndex: 9999,
            border: '2px solid #4a9eff',
            cursor: 'default',
            userSelect: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
        },
        version: {
            color: '#4a9eff',
            fontWeight: 'bold'
        },
        build: {
            color: '#888',
            marginLeft: '4px'
        }
    };

    const formatDate = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    };

    return (
        <div style={styles.container} title={`Build Date: ${formatDate(VERSION_INFO.buildDate)}\nCommit: ${VERSION_INFO.lastCommit}`}>
            v<span style={styles.version}>{VERSION_INFO.version}</span>
            <span style={styles.build}>(#{VERSION_INFO.build})</span>
        </div>
    );
};

export default VersionDisplay;
